import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'toro-turf-pro-api-token-dlg',
    templateUrl: './turf-pro-api-token-dlg.component.html',
    styleUrls: ['./turf-pro-api-token-dlg.component.less']
})
export class TurfProApiTokenDlgComponent {

    @Output() setApiKey = new EventEmitter<string>();
    @Output() cancelClick = new EventEmitter();

    @Input() apiKey: string;

    // =========================================================================================================================================================
    // Ctor and Lifecycle Hooks
    // =========================================================================================================================================================

    constructor() { }

    // =========================================================================================================================================================
    // Event Handlers
    // =========================================================================================================================================================

    onSetApiKey() {
        this.setApiKey.emit(this.apiKey);
    }

    onCancelDialog() {
        this.cancelClick.emit();
    }

}
